import React from "react";
import img from "../../assets/img/lolpic.png";

import "./profile.scss";

export default function Profile({ userData }) {
  return (
    <section className="profile">
      <div
        style={{
          backgroundImage: userData
            ? `url(
            http://ddragon.leagueoflegends.com/cdn/11.1.1/img/profileicon/${userData.profileIconId}.png
          )`
            : `url(${img})`,
        }}
        className="profile__pic"></div>
      <div className="nickname">
        <h1 className="nickname__header">
          {userData ? userData.name : "Mizantrop"}
        </h1>
        <button className="nickname__button">
          <i className="far fa-heart"></i> Favorites
        </button>
      </div>
      {/* <span className="rank">
        Ladder Rank <span>666</span> (0.6932% of top)
      </span>
      <div className="buttons">
        <button className="button">Update</button>
        <button className="button">Tier Graph</button>
        <h3>Last updated: 12 minutes ago</h3>
      </div> */}
    </section>
  );
}
